import { render, staticRenderFns } from "./lswt.vue?vue&type=template&id=1bfb8cc8&scoped=true&"
import script from "./lswt.vue?vue&type=script&lang=js&"
export * from "./lswt.vue?vue&type=script&lang=js&"
import style0 from "./lswt.vue?vue&type=style&index=0&id=1bfb8cc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb8cc8",
  null
  
)

export default component.exports